var UserDefinedTypeName = {
  print: function print(_ref) {
    var node = _ref.node;
    return node.namePath;
  }
};
module.exports = UserDefinedTypeName;